import './RecordContainer.scss';
import { Card } from 'antd';
import classNames from 'classnames';
import { ifClickHandler } from '@lib/events';
import React, { useMemo } from 'react';
export const SonarRecordContainer = ({ children, className, onClick }) => {
    const classes = classNames('animate sonar-record', className, {
        clickable: onClick
    });
    const handleOnClick = useMemo(() => ifClickHandler(onClick), [onClick]);
    return (React.createElement(Card, { className: classes, onClick: handleOnClick }, children));
};
